export default "__VITE_ASSET__BcMHZP1c__"